import { AntwoordMail } from "./antwoord-mail";

export class VraagMail {
    public constructor(init?: Partial<VraagMail>) {
      this.antwoorden = [];
      Object.assign(this, init);
    }

    vraagtitel: string;
    antwoorden: AntwoordMail[];
}
